module.exports = __webpack_public_path__ + "static/lab_members-17d21092e41bf58544c0ddcf23404977.jpg";